import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgICloudMail = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 16C0 8.458 0 4.686 2.343 2.343S8.458 0 16 0c7.543 0 11.314 0 13.657 2.343S32 8.458 32 16c0 7.543 0 11.314-2.343 13.657S23.543 32 16 32c-7.542 0-11.314 0-13.657-2.343S0 23.543 0 16Z"
      fill="url(#ICloudMail_svg__a)"
    />
    <path
      d="M7.011 9.1c-.169 0-.327.03-.478.089l3.011 3.1 3.045 3.155.055.067.09.09.088.088.178.189 2.611 2.678c.044.027.17.143.268.193.127.063.264.121.406.126a.963.963 0 0 0 .447-.105c.102-.05.148-.122.268-.214l3.022-3.123 3.056-3.144 2.944-3.033A1.292 1.292 0 0 0 25.4 9.1H7.011Zm-.922.378a1.751 1.751 0 0 0-.522 1.278v10.177c0 .418.134.798.355 1.09l.422-.4 3.145-3.056 2.789-2.7-.056-.067-3.055-3.144L6.11 9.5l-.022-.022Zm20.333.1-2.978 3.078L20.4 15.8l-.056.056 2.9 2.81 3.145 3.056.189.178c.17-.272.266-.606.266-.967V10.756c0-.46-.159-.878-.422-1.178Zm-13.789 6.655-2.777 2.7L6.7 21.99l-.4.389c.21.136.45.222.711.222H25.4c.313 0 .597-.12.833-.311l-.2-.2-3.155-3.056-2.9-2.8-2.611 2.69c-.142.093-.236.197-.374.26-.222.103-.466.19-.71.187-.245-.004-.486-.1-.706-.209-.11-.054-.17-.108-.3-.216l-2.644-2.712Z"
      fill="#fff"
    />
    <defs>
      <linearGradient
        id="ICloudMail_svg__a"
        x1={16}
        y1={0}
        x2={16}
        y2={32}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1D70F1" />
        <stop offset={1} stopColor="#1AC8FB" />
      </linearGradient>
    </defs>
  </svg>
);
const Memo = memo(SvgICloudMail);
export default Memo;
